import logo01 from '../assets/images/logo01.png';

export const ASSETS_IMG = {
  logo01,
};
